<template>
    <div class="backButton" @click="backButtonClick" :style="{zIndex: zIindex}">
        <div class="back">
            <img src="@/assets/img/details/back.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    data() { 
        return {

        }
    },
    methods: {
        backButtonClick(){
            this.$router.push({name: this.routerName});
        },
    },
    props: {
        routerName: {
            type: String
        },
        zIindex: {
            type: String,
            default: '0',
        }
    }
}
</script>

<style lang="scss" scoped>
.backButton{
    width: 1rem;
    height: 1rem;
    position: absolute;
    left: 0;
    top: 0;
    padding-left: .4rem;
    padding-top: .18rem;
    .back{
        width: .64rem;
        height: .64rem;
        border-radius: 50%;
        // background: rgba(0,0,0,.4);
        .img{
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-position: -1rem 0rem;
            background-size: 2rem 1.1rem;
        }
    }
}
</style>